import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import ProfileDetails from "../components/Profile/ProfileDetails";
import RangeSlider from "../components/Profile/RangeSlider";
import AdvisorSummaryCard from "../components/Advisors/AdvisorSummaryCard";
import AdvisorRecommendations from "../components/Advisors/AdvisorRecommendations";
import { apiServices } from "../services/Api";
import { useSelector } from "react-redux";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import ReviewModalSlider from "../components/Advisors/ReviewModalSlider";
import { safeJSONParse } from "../utils/jsonHelper";

const ProfileSummary = (props) => {
  const data = props.data;
  const showAdvDetails = props.showAdvDetails;
  const { auth, isLoggedIn, userId, user } = useSelector(
    (state) => state.advisorauth
  );

  // const tagStyle = {
  //     backgroundColor: "#9BE931",
  //     color: "white",
  //     fontWeight: "bold",
  // };

  console.log("data in modal", data);

  const [advisor, setAdvisor] = useState([]);

  const getAdvisor = async (userId) => {
    try {
      const advisorsData = await apiServices.get(`advisors/calls`);
      const data = advisorsData;
      setAdvisor(data);
      return data;
    } catch (e) {
      console.warn("Could not fetch advisor details:", e);
    }
  };

  useEffect(() => {
    if (userId) {
      getAdvisor(userId);
    }
  }, [userId]);

  return (
    <div className="flex flex-col gap-4 lg:gap-6 p-4 lg:p-6">
      {showAdvDetails && (
        <ProfileDetails
          name={user}
          dateCreate={data.createdAt}
          dateUpdate={data.updatedAt}
        />
      )}

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 p-4 lg:p-5 rounded-lg border border-brand-border bg-white">
        <div className="flex items-center gap-3 lg:gap-4 min-w-0">
          <span
            className={`inline-block px-2.5 lg:px-3 py-1 lg:py-1.5 rounded text-xs lg:text-sm font-bold ${
              data?.transactionType === "SELL"
                ? "bg-brand-red text-white"
                : "bg-primary-green text-white"
            }`}
          >
            {data.transactionType}
          </span>
          <p className="text-custom-darkGray text-lg lg:text-2xl font-bold truncate min-w-0 break-words">
            {data.tradingSymbol}
          </p>
        </div>
      </div>

      {/* Price Range Slider */}
      <div className="my-2 lg:my-4 px-2">
        <ReviewModalSlider
          minValue={data.stoploss}
          maxValue={data.targetPrice}
          startValue={data.entryPriceLower}
          endValue={data.entryPriceUpper}
        />
      </div>

      <div className="w-full">
        <AdvisorSummaryCard summaryData={data} />
      </div>

      <div className="flex flex-col gap-4 lg:gap-6 w-full">
        <AdvisorRecommendations
          comments={safeJSONParse(data?.comments, [])}
          recommendations={safeJSONParse(data?.recommendations, [])}
        />
      </div>
    </div>
  );
};

export default ProfileSummary;
